<template>
  <div class="property-detail-page">
    <!-- 页面标题 -->
    <section class="page-banner assets-banner">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>资产详情</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/assets' }">资产专区</el-breadcrumb-item>
          <el-breadcrumb-item>资产详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 资产详情内容 -->
    <section class="asset-detail-section" v-if="assetDetail">
        <div class="container detail-container">
            <div class="asset-detail-layout">
                <!-- 左侧主要内容 -->
                <div class="asset-detail-main">
                    <!-- 资产图片轮播 -->
                    <div class="asset-gallery" v-if="imageList && imageList.length > 0">
                        <div class="gallery-main">
                            <div class="main-image-slider">
                                <div class="slide-item active" data-type="image">
                                    <el-image 
                                        class="preview-image"
                                        :src="imageList[currentImageIndex]" 
                                        :preview-src-list="getPreviewList()"
                                        fit="contain"
                                    >
                                    </el-image>
                                </div>
                            </div>
                            <button class="gallery-prev" @click="prevImage" v-if="imageList.length > 1"><i class="el-icon-arrow-left"></i></button>
                            <button class="gallery-next" @click="nextImage" v-if="imageList.length > 1"><i class="el-icon-arrow-right"></i></button>
                            <div class="gallery-counter"><span class="current">{{ currentImageIndex + 1 }}</span> / <span class="total">{{ imageList.length }}</span></div>
                        </div>
                        <div class="gallery-thumbs" v-if="imageList.length > 1">
                            <div class="thumb-item" v-for="(img, idx) in imageList" :key="idx" 
                                 :class="{active: currentImageIndex === idx}" 
                                 @click="currentImageIndex = idx">
                                <img :src="img" alt="缩略图">
                            </div>
                        </div>
                    </div>

                    <!-- 资产标题 -->
                    <div class="asset-header">
                        <h1 class="asset-title">{{ assetDetail.assetName }}</h1>
                        <div class="asset-location" v-if="$store.state.siteConfig.showVisits === '1'">
                            <span class="tag tag-recommend"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>优质</span>
                            <span class="view-count"><i class="el-icon-view"></i> {{ assetDetail.visits }}</span>
                        </div>
                        <div class="tags">
                          <el-tag size="mini" v-for="value in assetDetail.tagsList" :key="value">{{ value }}</el-tag>
                        </div>
                    </div>

                    <!-- 标签切换 -->
                    <div class="detail-tabs">
                        <button class="tab-btn" :class="{active: currentTab === 'info'}" @click="currentTab = 'info'">资产情况</button>
                        <button v-if="pcMianze" class="tab-btn" :class="{active: currentTab === 'disclaimer'}" @click="currentTab = 'disclaimer'">免责声明</button>
                    </div>

                    <!-- 资产情况 -->
                    <div class="tab-content" :class="{active: currentTab === 'info'}" id="info">
                        <div class="info-section">
                           <h3>基本信息：</h3>
                           <div class="info-row" v-if="assetDetail.assetName">
                                <span class="info-label">资产名称：</span>
                                <span class="info-value">{{ assetDetail.assetName }}</span>
                            </div>
<!--                           <div class="info-row" v-if="assetDetail.assetPackageName">
                                <span class="info-label">资产包名称：</span>
                                <span class="info-value">{{ assetDetail.assetPackageName }}</span>
                            </div>-->
                             <div class="info-row" v-if="assetDetail.assetType">
                                <span class="info-label">资产所属：</span>
                                <span class="info-value">{{ assetDetail.assetType == "1" ? '辽宁资产管理有限公司' : '外部资产' }}</span>
                                <span class="info-label" v-if="assetDetail.entName">企业名称：</span>
                                <span class="info-value" v-if="assetDetail.entName">{{ assetDetail.entName }}</span>
                            </div>
                            <div class="info-row" v-if="assetDetail.assetValueType === 0 || assetDetail.priceMin || assetDetail.priceMax">
                                <span class="info-label">参考估值：</span>
                                <span class="info-value price" v-if="assetDetail.assetValueType === 0">面议</span>
                                <span class="info-value price" v-else>
                                  <span v-if="assetDetail.priceMin != '' && assetDetail.priceMax != ''">￥{{ assetDetail.priceMin }}万元 - {{ assetDetail.priceMax }}万元</span>
                                  <span v-if="assetDetail.priceMin != '' && assetDetail.priceMax == ''">￥{{ assetDetail.priceMin }}万元</span>
                                  <span v-if="assetDetail.priceMin == '' && assetDetail.priceMax != ''">￥{{ assetDetail.priceMax }}万元</span>
                                </span>
                                <span class="info-label" v-if="assetDetail.assetValue">资产价值：</span>
                                <span class="info-value  price" v-if="assetDetail.assetValue">{{ assetDetail.assetValue }}</span>
                            </div>



                            <div class="info-row" v-if="assetDetail.projectStartTime">
                                <span class="info-label">发布日期：</span>
                                <span class="info-value">{{ assetDetail.projectStartTime }}</span>
                              <span class="info-label" v-if="assetDetail.categoryId">资产类别：</span>
                              <span class="info-value" v-if="assetDetail.categoryId">{{ assetDetail.categoryName }}</span>
<!--                              <span class="info-label">资产状态：</span>
                              <span class="info-value">{{ getStatusLabel(assetDetail.status) }}</span>-->
<!--                                <span class="info-label">项目结束时间：</span>
                                <span class="info-value">{{ assetDetail.projectEndTime }}</span>-->
                            </div>
                      
                            <div class="info-row">
                              <span class="info-label">是否租赁：</span>
                              <span class="info-value">{{ assetDetail.isLease == '1' ? '租赁' : '不租赁' }}</span>
                              <span class="info-label" v-if="assetDetail.isLease == '1'">租赁状态：</span>
                              <span class="info-value" v-if="assetDetail.isLease == '1'">{{ assetDetail.leaseStatus === '1' ? '已租赁' : '未租赁' }}</span>
                              <span class="info-label" v-if="assetDetail.isLease == '1' && assetDetail.rentType === 0">租赁价格：</span>
                              <span class="info-value" v-if="assetDetail.isLease == '1' && assetDetail.rentType === 0"> 面议</span>
                              <span class="info-label" v-if="assetDetail.isLease == '1' && assetDetail.rentType === 1">租赁价格：</span>
                              <span class="info-value" v-if="assetDetail.isLease == '1' && assetDetail.rentType === 1">￥{{ assetDetail.rentValue }} 万元/年</span>
                            </div>

<!--                            <div class="info-row">
                                <span class="info-label">是否优质：</span>
                                <span class="info-value">{{ assetDetail.isRecommended == 'Y' ? '是' : '否' }}</span>
                                
                            </div>-->
                             <div class="info-row">
                                <span class="info-label" v-if="assetDetail.provinceName">省份：</span>
                                <span class="info-value" v-if="assetDetail.provinceName">{{ assetDetail.provinceName }}</span>
                                <span class="info-label" v-if="assetDetail.cityName">城市：</span>
                                <span class="info-value" v-if="assetDetail.cityName">{{ assetDetail.cityName}}</span>
                               <span class="info-label" v-if="assetDetail.provinceName">区/县：</span>
                               <span class="info-value" v-if="assetDetail.provinceName">{{ assetDetail.districtName }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">详细地址：</span>
                                <span>{{ assetDetail.address || (assetDetail.provinceName + assetDetail.cityName + assetDetail.districtName) }}</span>
                            </div>
                      
                            <div class="info-row-grid">
                                <div class="info-row-item" v-for="(ext, index) in assetDetail.extList" :key="index">
                                    <span class="info-label">{{ ext.extLabel }}</span>
                                    <span class="info-value">{{ ext.extValue }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="info-section" v-if="assetDetail.assetDesc">
                            <h3>资产介绍：</h3>
                            <div class="advantage-content">
                              <div v-html="assetDetail.assetDesc"></div>
                            </div>
                        </div>
                        <div class="info-section" v-if=" assetDetail.highlightDesc">
                            <h3>资产特质</h3>
                            <div class="advantage-content">
<!--                                <div class="advantage-zcys" v-if="assetDetail.highlightDesc">{{ assetDetail.highlightDesc }}</div>-->
                                <div v-html="assetDetail.highlightDesc"></div>
                            </div>
                        </div>

                        <div class="info-section" v-if="assetDetail.attachmentList && assetDetail.attachmentList.length > 0">
                            <h3>附件下载：</h3>
                            <div class="advantage-content">
                                <div class="attachment-list">
                                    <div class="attachment-item" v-for="(file, index) in assetDetail.attachmentList" :key="index">
                                        <div class="file-info" @click="handleFileClick(file)">
                                            <i :class="getFileIcon(file)"></i>
                                            <span class="file-name" :title="getFileName(file)">{{ getFileName(file) }}</span>
                                        </div>
                                        <el-button type="primary" size="small" icon="el-icon-download" plain @click="downloadFile(file)">
                                            下载
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="info-section"v-if="assetDetail.remark">
                            <h3>备注：</h3>
                            <div class="advantage-content">
                                <div >{{ assetDetail.remark }}</div>
                            </div>
                        </div>
                        <div class="info-section" v-if="$store.state.siteConfig.showMap === '1'">
                            <h3>地图：</h3>
                            <div class="map-view">
                                <BaiduMap
                                    v-if="!mapError && assetDetail && (assetDetail.address || assetDetail.provinceName)"
                                    :address="assetDetail.address || (assetDetail.provinceName + assetDetail.cityName + assetDetail.districtName)"
                                    title="资产位置"
                                    height="350px"
                                    @error="mapError = true"
                                />
                                <div v-else-if="assetDetail && assetDetail.addressImg" class="map-fallback">
                                    <img :src="assetDetail.addressImg" style="width: 100%; height: 350px; object-fit: cover; border-radius: 8px;">
                                </div>
                            </div>
                        </div>
                        <!-- 暂不支持单独嵌入高德地图URL因为资产数据未含经纬度参数，可依赖后端后期补充 -->
                    </div>

                    <!-- 免责声明 -->
                    <div class="tab-content" v-if="pcMianze" :class="{active: currentTab === 'disclaimer'}" id="disclaimer">
                        <div v-html="pcMianze.value">
                           
                        </div>
                    </div>

                    <!-- 上一篇下一篇导航 -->
                    <div class="article-nav">
                        <div class="prev-article">
                            <router-link v-if="prevAsset" :to="{ path: '/property/detail', query: { id: prevAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, isLease: isLease, from: from } }" style="text-decoration: none;">
                                <span class="nav-label"><i class="el-icon-arrow-left"></i> 上一篇</span>
                            </router-link>
                            <router-link v-if="prevAsset" :to="{ path: '/property/detail', query: { id: prevAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, isLease: isLease, from: from } }" class="nav-title">
                                {{ prevAsset.assetName }}
                            </router-link>
                        </div>
                        <div class="next-article">
                            <router-link v-if="nextAsset" :to="{ path: '/property/detail', query: { id: nextAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, isLease: isLease, from: from } }"  style="text-decoration: none;">
                                <span class="nav-label">下一篇 <i class="el-icon-arrow-right"></i></span>
                            </router-link>
                            <router-link v-if="nextAsset" :to="{ path: '/property/detail', query: { id: nextAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, isLease: isLease, from: from } }" class="nav-title">
                                {{ nextAsset.assetName }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <!-- 右侧联系信息 -->
                <aside class="asset-detail-sidebar">
                    <div class="contact-card">
                        <div class="contact-person">
                            <div class="contact-avatar-wrap">
                                <img v-if="assetDetail.contactPhoto" :src="assetDetail.contactPhoto" alt="联系人" class="contact-avatar">
                                <div v-else class="contact-avatar-text">{{ getFirstChar(assetDetail.contactPerson || '咨') }}</div>
                            </div>
                            <div class="contact-name">{{ assetDetail.contactPersonAbbr || assetDetail.contactPerson || '联系人' }}</div>
                        </div>
                        <div class="contact-divider"></div>
                        <div class="contact-item" v-if="assetDetail.contactPhone">
                            <i class="el-icon-phone-outline"></i>
                            <span>{{ assetDetail.contactPhone }}</span>
                        </div>
                        <div class="contact-item" v-if="assetDetail.contactEmail">
                            <i class="el-icon-message"></i>
                            <span>{{ assetDetail.contactEmail }}</span>
                        </div>
                        <div class="contact-item" v-if="assetDetail.contactAddress">
                            <i class="el-icon-location-outline"></i>
                            <span>{{ assetDetail.contactAddress }}</span>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </section>
    <div v-else class="container detail-container" style="margin-top: 40px;">
      <div class="empty-state">
        <el-skeleton :rows="10" animated />
      </div>
    </div>

  </div>
</template>

<script>
import { getBannerList, getPropertyDetail, getLabelList, getPrevNextSolrProperty } from '@/api/menu'
import BaiduMap from '@/components/BaiduMap.vue'

export default {
  name: 'PropertyDetail',
  components: { BaiduMap },
  data() {
    return {
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      assetDetail: null,
      assetId: this.$route.query.id,
      keyword: this.$route.query.keyword || '',
      categoryId: this.$route.query.categoryId || '',
      assetType: this.$route.query.assetType || '',
      sort: this.$route.query.sort || '',
      isLease: this.$route.query.isLease || '',
      from: this.$route.query.from || '',
      sign: this.$route.query.sign || '',
      imageList: [],
      currentImageIndex: 0,
      currentTab: 'info',
      pcMianze: null,
      mapError: false,
      prevAsset: null,
      nextAsset: null
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.assetId = newId;
          this.keyword = this.$route.query.keyword || '';
          this.categoryId = this.$route.query.categoryId || '';
          this.assetType = this.$route.query.assetType || '';
          this.sort = this.$route.query.sort || '';
          this.isLease = this.$route.query.isLease || '';
          this.from = this.$route.query.from || '';
          this.fetchPropertyDetail();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      immediate: false
    }
  },
  created() {
    this.fetchBanner("zczq");
    this.fetchLabel("pcMianze");
    if(this.assetId) {
      this.fetchPropertyDetail();
    }
  },
  mounted() {
    this.startBannerTimer();
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
  },
  methods: {
    async fetchLabel(name) {
      try {
        const res = await getLabelList({ name })
        if (res.code === 0) {
          this.pcMianze = res.data
        } 
      } catch (error) {
        console.error('获取免责声明失败', error)
      }
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchPropertyDetail() {
      try {
        const res = await getPropertyDetail(this.assetId, this.sign)
        if (res.code === 0 || res.code === 200) {
          this.assetDetail = res.data;
          this.processImages();
          if (this.sign != '1') {
            // 获取前后资产信息
            this.fetchPrevNext(this.assetDetail.infoType);
          }

          // 设置页面标题
          this.setPageTitle(res.data.assetName + '-资产详情' || '资产详情')
        }
      } catch (error) {
        console.error('获取资产详情失败', error)
      }
    },
    setPageTitle(detailTitle) {
      const siteTitle = this.$store.state.siteConfig.showTitle || '辽宁资产管理有限公司'
      document.title = `${detailTitle} - ${siteTitle}`
    },
    async fetchPrevNext(infoType) {
        try {
          // 当 categoryId 是 'all' 时，转换为空字符串，和 fetchProperty 保持一致
          const reqCategoryId = this.categoryId === 'all' ? '' : this.categoryId;
          // 当 sort 是 'default' 时，转换为空字符串
          const reqSort = this.sort === 'default' ? '' : this.sort;
          // assetType 特殊处理：和列表页保持一致
          let assetTypeValue = this.assetType;
          if(this.$store.state.siteConfig.showExtData === '0'){
            assetTypeValue = '1';
          }
          // isLease 参数应该根据 infoType 来确定，和列表页保持一致
          let isLeaseValue = '';
          if (infoType == 'sys_content_type_property_02') {
            isLeaseValue = '1';
          }
          const res = await getPrevNextSolrProperty(
              infoType, 
              this.assetId, 
              this.keyword, 
              isLeaseValue, 
              assetTypeValue, 
              reqSort, 
              reqCategoryId
          );
          if (res.code === 0 || res.code === 200) {
            this.prevAsset = res.data?.prev ?? null;
            this.nextAsset = res.data?.next ?? null;
          }
        } catch (error) {
          console.error('获取前后资产失败', error);
          this.prevAsset = null;
          this.nextAsset = null;
        }
      },
    processImages() {
      const list = [];
      // if (this.assetDetail.coverImage) {
      //   list.push(this.assetDetail.coverImage);
      // }
      if (this.assetDetail.images) {
        // split by comma if there are multiple images
        const imgs = this.assetDetail.images.split(',').filter(i => i.trim());
        imgs.forEach(img => {
          if (!list.includes(img.trim())) {
            list.push(img.trim());
          }
        });
      }
      this.imageList = list;
    },
    prevImage() {
      if (this.imageList.length > 0) {
        this.currentImageIndex = this.currentImageIndex > 0 ? this.currentImageIndex - 1 : this.imageList.length - 1;
      }
    },
    nextImage() {
      if (this.imageList.length > 0) {
        this.currentImageIndex = this.currentImageIndex < this.imageList.length - 1 ? this.currentImageIndex + 1 : 0;
      }
    },
    getOriginalImage(url) {
      if (!url) return '';
      return url.replace('_1024x768', '').replace(/\.jpg$/, '');
    },
    getPreviewList() {
      if (!this.imageList || this.imageList.length === 0) return [];
      const originalList = this.imageList.map(url => this.getOriginalImage(url));
      return [
        ...originalList.slice(this.currentImageIndex),
        ...originalList.slice(0, this.currentImageIndex)
      ];
    },
    getStatusLabel(status) {
      const statusMap = {
        '0': '待处置',
        '1': '处置中',
        '2': '已处置',
        '3': '已撤销'
      };
      return statusMap[status] || status || '未知状态';
    },
    parseDateString(val) {
      return val ? val.split(' ')[0] : '';
    },
    getFileName(file) {
      return file.fileName || file.name || file.title || '未知文件';
    },
    getFileUrl(file) {
      let url = file.saveName || file.fileUrl || file.url || file.filePath || file.path || '';
      if (url && !url.startsWith('http') && !url.startsWith('/')) {
        url = '/' + url;
      }
      return url;
    },
    getFileExtension(filename) {
      if (!filename) return '';
      const parts = filename.split('.');
      return parts.length > 1 ? parts.pop().toLowerCase() : '';
    },
    getFileIcon(file) {
      const ext = this.getFileExtension(this.getFileName(file));
      if (['pdf'].includes(ext)) return 'el-icon-document';
      if (['doc', 'docx'].includes(ext)) return 'el-icon-document';
      if (['xls', 'xlsx'].includes(ext)) return 'el-icon-data-line';
      if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) return 'el-icon-picture-outline';
      if (['zip', 'rar', '7z'].includes(ext)) return 'el-icon-collection';
      return 'el-icon-paperclip';
    },
    isPreviewable(file) {
      const ext = this.getFileExtension(this.getFileName(file));
      return ['pdf', 'jpg', 'jpeg', 'png', 'gif'].includes(ext);
    },
    handleFileClick(file) {
      const url = this.getFileUrl(file);
      if (!url) {
        this.$message.warning('附件链接不存在');
        return;
      }
      if (this.isPreviewable(file)) {
        window.open(url, '_blank');
      } else {
        this.downloadFile(file);
      }
    },
    downloadFile(file) {
      const url = this.getFileUrl(file);
      if (!url) {
        this.$message.warning('附件链接不存在');
        return;
      }
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = this.getFileName(file);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getFirstChar(name) {
      if (!name) return '咨';
      return name.charAt(0);
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-blue: #1a3a5c;
$primary-red: #c0392b;
$box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

.page-banner {
  background-size: cover;
  background-color: $primary-blue;
  color: #fff;
  padding: 60px 0;
  position: relative;
  
  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }

  h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 15px 0;
    letter-spacing: 2px;
  }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #fff !important;
  }
}

.asset-detail-section {
    padding: 40px 0;
    background-color: #f8f9fa;
    min-height: 50vh;
}

.detail-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.asset-detail-layout {
    display: flex;
    gap: 30px;
    align-items: flex-start;
}

.asset-detail-main {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    box-shadow: $box-shadow;
    overflow: hidden;
    padding: 40px;
}

.asset-gallery {
    margin-bottom: 30px;
}

.gallery-main {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 15px;
    background: #000;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-image-slider {
    width: 100%;
    height: 100%;
    min-width: 0;
}

.slide-item {
    display: none;
    width: 100%;
    height: 100%;
    &.active { display: block; }
    img { width: 100%; height: 100%; object-fit: contain; }
    .preview-image { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
}

.gallery-prev, .gallery-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0,0,0,0.5);
    color: #fff;
    border: none;
    width: 40px; height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: background 0.3s;
    font-size: 18px;
    &:hover { background: $primary-red; }
}
.gallery-prev { left: 15px; }
.gallery-next { right: 15px; }

.gallery-counter {
    position: absolute;
    bottom: 15px; right: 15px;
    background: rgba(0,0,0,0.6);
    color: #fff;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
}

.gallery-thumbs {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    padding-bottom: 10px;
    scrollbar-width: thin;
    
    .thumb-item {
        width: 100px; height: 75px;
        border-radius: 4px; overflow: hidden;
        cursor: pointer;
        opacity: 0.6;
        transition: all 0.3s;
        border: 2px solid transparent;
        flex-shrink: 0;
        
        &.active, &:hover { opacity: 1; border-color: $primary-red; }
        img { width: 100%; height: 100%; object-fit: cover; }
    }
}

.asset-header {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;

    .asset-title {
        font-size: 24px; color: #333; margin: 0 0 15px 0; line-height: 1.4;
    }

    .asset-location {
        color: #666; font-size: 14px; display: flex; align-items: center; gap: 8px;
        i { color: $primary-red; }
        .view-count { margin-left: auto; color: #999; font-size: 14px; }
    }
}

.detail-tabs {
    display: flex; border-bottom: 2px solid #eee; margin-bottom: 25px;
    
    .tab-btn {
        padding: 12px 30px; border: none; background: transparent;
        font-size: 16px; color: #666; cursor: pointer;
        position: relative; transition: all 0.3s;
        
        &::after {
            content: ''; position: absolute; bottom: -2px; left: 0; width: 100%; height: 2px;
            background: $primary-red; transform: scaleX(0); transition: transform 0.3s;
        }
        
        &.active {
            color: $primary-red; font-weight: 500;
            &::after { transform: scaleX(1); }
        }
    }
}

.tab-content {
    display: none;
    &.active { display: block; animation: fadeIn 0.4s ease-out; }
}

.info-section {
    margin-bottom: 30px;

    .info-row {
        display: flex; margin-bottom: 15px; font-size: 14px;
        border-bottom: 1px dashed #ddd;
        padding-bottom: 15px;
        .info-label { width: 100px; color: #666; }
        .info-value {
            flex: 1; color: #333; font-weight: 500;
            &.price { color: $primary-red; font-size: 14px; font-weight: bold; }
            .buy-link { color: $primary-blue; text-decoration: underline; }
        }
    }

    .info-row-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0 30px;
    }
    
    .info-row-item {
        display: flex;
        margin-bottom: 15px;
        font-size: 14px;
        border-bottom: 1px dashed #ddd;
        padding-bottom: 15px;
        .info-label { width: 100px; color: #666; flex-shrink: 0; }
        .info-value { flex: 1; color: #333; font-weight: 500; word-break: break-all; }
    }
    
    h3 { font-size: 16px; margin: 0 0 15px 0; color: #333; border-left: 2px solid #1e3a5f;padding-left: 5px;}
    
    .advantage-content {
        line-height: 1.8; color: #555;
        p { margin-bottom: 10px; }
        .advantage-zcys {
          padding: 15px;
          background: #f8f8f8;
          border-radius: 8px;
          font-size: 14px;
          margin-bottom:15px
        }
    }

}

.disclaimer-content {
    line-height: 2; color: #666; background: #f9f9f9; padding: 20px; border-radius: 8px;
}

.asset-detail-sidebar {
    width: 320px; flex-shrink: 0;

    .contact-card {
        background: #fff; border-radius: 8px; box-shadow: $box-shadow; padding: 30px;
        position: sticky; top: 100px;
    }

    .contact-person {
        text-align: center; margin-bottom: 20px;
        
        .contact-avatar-wrap {
            width: 80px; height: 80px; border-radius: 50%; overflow: hidden;
            margin: 0 auto 15px; border: 3px solid #f0f2f5;
        }
        
        .contact-avatar { width: 100%; height: 100%; object-fit: cover; }
        .contact-avatar-text {
            width: 100%;
            height: 100%;
            background-color: #a2b1ff;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-weight: bold;
        }
        .contact-name { font-size:  14px; font-weight: 600; color: #333; }
    }

    .contact-divider { height: 1px; background: #eee; margin: 20px 0; }

    .contact-item {
        display: flex; align-items: flex-start; gap: 15px; margin-bottom: 15px; color: #666;font-size:14px;
        
        i { color: $primary-red; width: 20px; text-align: center; font-size: 14px; margin-top: 3px; }
        span { flex: 1; line-height: 1.5; word-break: break-all; }
    }
}

.empty-state {
    background: #fff; padding: 50px; border-radius: 8px; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  background: #f8f8f8;
  border-radius: 6px;
  transition: all 0.2s;
  
  &:hover {
    background: #f0f4f8;
  }
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex: 1;
  overflow: hidden;
  
  i {
    font-size: 18px;
    color: #1a3a5c;
  }
  
  .file-name {
    color: #333;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: color 0.2s;
  }
  
  &:hover .file-name {
    color: #c0392b;
    text-decoration: underline;
  }
}

.tags {
    
    span{margin-right: 10px;margin-top: 10px;}
}

.article-nav {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e8edf3;
  padding-top: 25px;
  margin-top: 40px;
  
  .prev-article, .next-article {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 48%;
  }
  
  .next-article {
    text-align: right;
    align-items: flex-end;
  }
  
  .nav-label {
    font-size: 0.85rem;
    color: #666;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: color 0.3s;
  }
  
  .nav-title {
    font-size: 0.95rem;
    color: #333;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.3s;
    text-decoration: none;
    &:hover {
      color: #b33939;
    }
  }
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* 防止富文本内容撑破容器 */
::v-deep .tab-content img,
::v-deep .info-section img {
    max-width: 100%;
    height: auto !important;
}

@media (max-width: 991px) {
    .asset-detail-layout { flex-direction: column; }
    .asset-detail-sidebar { width: 100%; }
    .contact-card { position: static; }
    .info-section .info-row-grid { grid-template-columns: 1fr; gap: 0; }
}

@media (max-width: 767px) {
    .page-banner { padding: 30px 0; h1 { font-size: 1.6rem; } }
    .asset-detail-main {
        padding: 15px;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }
    .gallery-main {
        height: 220px;
      
        max-width: 100%;
        margin: 0 auto 15px;
        box-sizing: border-box;
    }
    .detail-tabs .tab-btn { padding: 10px 15px; font-size: 0.95rem; }
    
    /* 手机端缩略图多行显示，支持自动换行且尺寸更小 */
    .gallery-thumbs {
        overflow-x: hidden;
        flex-wrap: wrap;
        padding-bottom: 0;
        gap: 8px;
        
        .thumb-item {
            box-sizing: border-box;
            flex-shrink: 1;
            width: calc(20% - 6.4px);
            height: 48px;
        }
    }
    
    .info-section .info-row {
        flex-wrap: wrap; /* 允许换行堆叠 */
        .info-label { width: 100%; margin-bottom: 4px; color: #888; }
        .info-value { width: 100%; margin-bottom: 10px; }
    }
    
    .info-section .info-row-item {
        flex-direction: column;
        gap: 4px;
        .info-label { width: 100%; color: #888; }
    }

    /* 手机端翻页：改为上下排列，但各自的标签和标题在一行显示 */
    .article-nav {
        flex-direction: column;
        gap: 15px;
        
        .prev-article, .next-article {
            max-width: 100%;
            width: 100%;
            flex-direction: row; /* 水平排列 */
            align-items: center; /* 垂直居中 */
            justify-content: flex-start; /* 全部左对齐 */
            text-align: left; /* 重置PC端的右对齐，确保文本靠左 */
        }
        
        .prev-article > a:first-child, 
        .next-article > a:first-child {
            flex-shrink: 0; /* 防止“上一篇”文本被长标题挤压变形 */
        }

        .nav-label {
            margin-bottom: 0;
        }

        .nav-title {
            white-space: nowrap;     /* 标题单行显示 */
            overflow: hidden;        /* 超出部分隐藏 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
            flex: 1;                 /* 撑满剩余屏幕宽度 */
            min-width: 0;            /* 关键：修复 flex 布局下文字截断失效的问题 */
        }
    }
}
</style>
